module.exports = __webpack_public_path__ + "static/media/discount-code-dollar.eecc7f1f.svg";